import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import React from 'react'
import { ChargingSessionStatus } from '../../charging-sessions/types'
import { Filter } from '@e3dc-react/shell/Elements/Filter'
import { useChargingSessionsStatus } from '../../charging-sessions/hooks/use-charging-sessions-status'

interface ChargingSessionStatusFilterProps {
  value: ChargingSessionStatus[]
  onChange: (value: ChargingSessionStatus[]) => void
  disabled?: boolean
  options: ChargingSessionStatus[]
}

/**
 * Reusable dropdown/filter component with predefined options and label for filtering charging sessions by status.
 *
 * @param value an array of ChargingSessionStatus values, so that none, one or multiple statuses can be selected at once
 * @param onChange an array of ChargingSessionStatus values. If no selection -> returns empty array, otherwise returns one or more elements
 * @param disabled disable selection
 * @constructor
 */
export const ChargingSessionStatusFilter: React.FC<ChargingSessionStatusFilterProps> = ({ value, onChange, disabled, options }) => {
  const { t } = useCustomTranslation()

  const chargingSessionStatusOptions = useChargingSessionsStatus(options)

  return (
    <Filter
      label={t('emobility.chargingSession.status')}
      options={chargingSessionStatusOptions}
      value={value}
      onChange={onChange}
      disabled={disabled}
    />
  )
}
